import { API_URL } from '../../../app-config/constants';
import { get, put } from '../request';

export type GoogleAppsLoginConfig = {
    id: string;
    enableLogin: boolean;
    allowRegularLogin: boolean;
};

const ENTRY = `${API_URL}/google-apps-login`;

getConfig.operation = 'READ';
export function getConfig(company?: string) {
    return get<GoogleAppsLoginConfig>(ENTRY, { getData: { company } });
}

updateConfig.operation = 'UPDATE';
export function updateConfig(config: GoogleAppsLoginConfig, waitFor?: Promise<unknown>) {
    return Promise.all([put<void>(ENTRY, { postData: config }), waitFor]).then(res => res[0]);
}
